import { render, staticRenderFns } from "./PrintItems.vue?vue&type=template&id=63599f80&scoped=true&"
import script from "./PrintItems.vue?vue&type=script&lang=js&"
export * from "./PrintItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63599f80",
  null
  
)

export default component.exports